// extracted by mini-css-extract-plugin
export default {"timer":"Z0-z","loaded":"_0-z"};